import React, { Component } from 'react';
import Main from './Components/Main';
class App extends Component {
  render() {
    return (
      <Main/>
    );
  }
}

export default App;
